__turbopack_context__.v({
  "facebook-input": "styles-module__gyN0EG__facebook-input",
  "image-wrapper": "styles-module__gyN0EG__image-wrapper",
  "span-vertical-spacer": "styles-module__gyN0EG__span-vertical-spacer",
  "uploaded-image-wrapper": "styles-module__gyN0EG__uploaded-image-wrapper",
});
